module.exports = __webpack_public_path__ + "static/media/001_mabataki.a549ae17.gif";